module.exports = __webpack_public_path__ + "static/media/listing-page-coonoor.ca4e2f37.webp";